import * as React from 'react';
import { useDispatch } from 'react-redux';
import { TDispatch } from '../../../../../../redux';
import { joinFairPlayInit } from '../../../../../../redux/reducers';
import { OnlyForFairPlayersInitial } from './OnlyForFairPlayersInitial';

export const OnlyForFairPlayersInitialContainer = () => {
  const dispatch = useDispatch<TDispatch>();

  const handleClickFairPlayButton = React.useCallback(() => {
    dispatch(joinFairPlayInit());
  }, [dispatch]);

  return <OnlyForFairPlayersInitial onClickFairPlayButton={handleClickFairPlayButton} />;
};
